import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import ReservationService from '~/services/ReservationService';

import { propertyQueryKeys } from './useGetProperty';

interface DeleteOfferBuilderRoomParams {
  propertyId: string;
  roomId: string;
  roomName?: string;
}

export function useDeleteOfferBuilderRoom() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ propertyId, roomId }: DeleteOfferBuilderRoomParams) => {
      await ReservationService.deleteRoomType(propertyId, roomId);
    },
    onSuccess: (_response, variables) => {
      queryClient.invalidateQueries({ queryKey: propertyQueryKeys.detail(variables.propertyId) });
      enqueueSnackbar(`${variables.roomName || 'Room'} deleted`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to delete room: ${error.message}`, { variant: 'error' });
    },
  });
}
